import { WebStorageError } from "./WebStorageError";

/**
 * sessionStorageから値を取得する関数。
 * 値が取得できなかった場合は空文字を返す。
 */
export const getSessionStorage = (key: string) => {
	try {
		const value = sessionStorage.getItem(key);
		return value || '';
	} catch (error) {
		// WebStorageErrorはsetSessionStorage()で処理するため、エラーログの出力のみとする
		console.error(error);
		return '';
	}
};

/**
 * sessionStorageに値を格納する関数。
 */
export const setSessionStorage = (key: string, value: string) => {
	try {
		sessionStorage.setItem(key, value);
	} catch (error) {
		console.error(error);
		throw new WebStorageError('setSessionStorage error');
	}
};

/**
 * sessionStorageに格納された値を削除する関数。
 */
export const removeSessionStorage = (key: string) => {
	try {
		sessionStorage.removeItem(key);
	} catch (error) {
		// WebStorageErrorはsetSessionStorage()で処理するため、エラーログの出力のみとする
		console.error(error);
	}
};
